import { mapNullable } from 'annotation-tools/utils';
import { IRectToRawRectangle } from '../../types/common/raw-rectangle';
import {
  ImageInfoAPIRawRequestBodyType,
  ImageInfoAPIRequestBodyType
} from '../../types/image-info/api-request-body';

export const ImageInfoAPIRequestBody = ({
  fileGuid,
  cropRect
}: ImageInfoAPIRequestBodyType): ImageInfoAPIRawRequestBodyType => ({
  file_guid: fileGuid,
  crop_option: mapNullable(cropRect, IRectToRawRectangle)
});

export const ImageInfoAPIRequestBodyPartial = ({
  fileGuid,
  cropRect
}: Partial<
  ImageInfoAPIRequestBodyType
>): Partial<ImageInfoAPIRawRequestBodyType> => ({
  file_guid: fileGuid,
  crop_option: mapNullable(cropRect, IRectToRawRectangle)
});
